// extracted by mini-css-extract-plugin
export default {"game":"Play_game__tT-Y1","bar":"Play_bar__-GIJ8","orientation":"Play_orientation__VxqvR","shooting":"Play_shooting__wRqsz","fill":"Play_fill__rju6i"};